import {
  RotateCw,
  Sticker,
  IdCard,
  FileCheck,
  MapPinned,
  ScanLine,
  FileStack,
  Users,
  Truck,
  ArrowUpRight,
} from "lucide-react";
import { SERVICES } from "@/lib/site";

const ICONS = {
  RotateCw,
  Sticker,
  IdCard,
  FileCheck,
  MapPinned,
  ScanLine,
  FileStack,
  Users,
  Truck,
};

// Bento span pattern: 9 items
const SPANS = [
  "md:col-span-2 lg:col-span-2",
  "md:col-span-1 lg:col-span-1",
  "md:col-span-1 lg:col-span-1",
  "md:col-span-1 lg:col-span-1",
  "md:col-span-1 lg:col-span-1",
  "md:col-span-2 lg:col-span-2",
  "md:col-span-1 lg:col-span-1",
  "md:col-span-1 lg:col-span-1",
  "md:col-span-2 lg:col-span-2",
];

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative py-24 sm:py-32 bg-slate-50"
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="max-w-3xl">
          <div className="text-xs font-bold uppercase tracking-[0.22em] text-blue-600">
            Our Expertise
          </div>
          <h2 className="mt-4 font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tighter text-slate-900 leading-[1.05]">
            Every DMV task,
            <br />
            handled in one stop.
          </h2>
          <p className="mt-6 text-lg text-slate-600 leading-relaxed">
            Fast. Simple. Done right. We take care of the paperwork so you stay
            compliant and get back on the road with confidence.
          </p>
        </div>

        <div
          data-testid="services-grid"
          className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6"
        >
          {SERVICES.map((s, i) => {
            const Icon = ICONS[s.icon] || FileCheck;
            const span = SPANS[i] || "";
            return (
              <article
                key={s.value}
                data-testid={`service-card-${s.value}`}
                className={`group relative ${span} bg-white border border-slate-200 rounded-2xl p-7 hover:-translate-y-1 hover:shadow-lg hover:border-blue-200 transition-all duration-300`}
              >
                <div className="flex items-start justify-between">
                  <div className="h-12 w-12 rounded-xl bg-blue-50 text-blue-600 grid place-items-center ring-1 ring-blue-100 group-hover:bg-blue-600 group-hover:text-white transition-colors">
                    <Icon className="h-6 w-6" />
                  </div>
                  <ArrowUpRight className="h-5 w-5 text-slate-300 group-hover:text-blue-600 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-all" />
                </div>
                <h3 className="mt-6 font-display text-xl font-semibold text-slate-900 tracking-tight">
                  {s.label}
                </h3>
                <p className="mt-2 text-[15px] text-slate-600 leading-relaxed">
                  {s.blurb}
                </p>
                <a
                  href="#book"
                  data-testid={`service-book-${s.value}`}
                  className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-blue-600 hover:text-blue-700"
                >
                  Book this service
                  <ArrowUpRight className="h-4 w-4" />
                </a>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
